import React from 'react';
import {
  EmailShareButton,
  TwitterShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from 'react-share';
import {
  Box,
  Button,
  IconButton,
  Typography,
} from '@mui/material';
import {
  BoldSmsIcon, CloseSquareIcon, FacebookRoundIcon, LinkedInIcon, TwitterIcon, WhatsAppIcon,
} from 'assets/icons';
import { CustomModal } from 'components/molecules';
import './styles.scss';

interface IShareModalProps {
  open: boolean;
  onClose: () => void;
  modalTitle: string;
  shareTitle: string;
  shareUrl: string;
}

const ShareModal = ({
  open,
  onClose,
  modalTitle,
  shareTitle,
  shareUrl,
}: IShareModalProps) => (
  <CustomModal open={open} onClose={() => {}} modalClass="share-modal">
    <>
      <div className="d-flex justify-content-between align-items-start mb-4 close-modal-header">
        <div className="d-flex flex-column">
          <Typography variant="h5" component="h5" sx={{ mb: 1 }}>{modalTitle}</Typography>
        </div>
        <IconButton onClick={onClose} sx={{ p: 0 }}>
          <CloseSquareIcon sx={{ color: 'primary.main' }} />
        </IconButton>
      </div>
      <div className="close-modal-body">
        <Box display="flex" gap={4} flexWrap="wrap">
          <FacebookShareButton url={shareUrl} title={shareTitle}>
            <Button variant="outlined" sx={{ alignItems: 'center', gap: 2 }}>
              <FacebookRoundIcon
                width="20"
                height="20"
                viewBox="0 0 20 20"
                sx={{ fontSize: 20 }}
              />
              <Typography fontWeight={600} variant="body2">
                Facebook
              </Typography>
            </Button>
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl} title={shareTitle}>
            <Button variant="outlined" sx={{ alignItems: 'center', gap: 2 }}>
              <TwitterIcon
                width="32"
                height="32"
                viewBox="0 0 32 32"
                sx={{ fontSize: 20, color: '#00acee' }}
              />
              <Typography fontWeight={600} variant="body2">
                Twitter
              </Typography>
            </Button>
          </TwitterShareButton>
          <WhatsappShareButton url={shareUrl} title={shareTitle}>
            <Button variant="outlined" sx={{ alignItems: 'center', gap: 2 }}>
              <WhatsAppIcon sx={{ fontSize: 20 }} />
              <Typography fontWeight={600} variant="body2">
                Whatsapp
              </Typography>
            </Button>
          </WhatsappShareButton>
          <LinkedinShareButton url={shareUrl} title={shareTitle}>
            <Button variant="outlined" sx={{ alignItems: 'center', gap: 2 }}>
              <LinkedInIcon sx={{ fontSize: 20 }} />
              <Typography fontWeight={600} variant="body2">
                Linkedin
              </Typography>
            </Button>
          </LinkedinShareButton>
          <EmailShareButton url={shareUrl} title={shareTitle}>
            <Button variant="outlined" sx={{ alignItems: 'center', gap: 2 }}>
              <BoldSmsIcon sx={{ fontSize: 20 }} />
              <Typography fontWeight={600} variant="body2">
                Email
              </Typography>
            </Button>
          </EmailShareButton>
        </Box>
      </div>
    </>
  </CustomModal>
);

export default ShareModal;
